import Stores from './Stores';

export default Stores;


// WEBPACK FOOTER //
// ./src/components/Query/Stores/index.ts